export default class InViewController extends Classy {
  constructor() {
    let settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    // The items that are being watched
    this.items = [];
    // The selectors that are being watched
    this.selectors = [];
    // Some throttles / timeouts
    this.timeouts = {};

    // An intersection observer
    this.IntersectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) this.enter(entry.target);else this.exit(entry.target);
      });
    }, settings);

    // Each time the page content updates, update the items
    this.MutationObserver = new MutationObserver(() => this.update());

    // Observes the entire document
    this.MutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  watch(selector) {
    // If this selector is already being watched, return
    if (this.selectors.includes(selector)) return;

    // Add the selector to the list of selectors
    this.selectors.push(selector);

    // Update the items
    this.update();

    // The watch callback
    this.callback('watch', this.selectors);
  }
  update() {
    // Clear the update timeout
    clearTimeout(this.timeouts['update']);

    // Set the update timeout
    this.timeouts['update'] = setTimeout(() => {
      // Loop through all the items, and check if they are still on the page
      this.items.forEach(item => {
        // If the item is still on the page, continue
        if (document.body.contains(item)) return;
        // Remove the item from the list of items
        this.items.splice(this.items.indexOf(item), 1);
        // Unobserve the item
        this.IntersectionObserver.unobserve(item);
      });

      // Loop through the selectors
      this.selectors.forEach(selector => {
        // Loop through all the elements on the page that match the selector
        [...document.querySelectorAll(selector)].forEach(element => {
          // If this element is already being watched, return
          if (this.items.includes(element)) return;
          // Add the element to the intersection observer
          this.IntersectionObserver.observe(element);
          // Add the element to the list of items
          this.items.push(element);
          // Call the init callback
          this.init(element);
        });
      });

      // Call the update callback
      this.callback('update', this.items);
    }, 100);
  }
  enter(item) {
    this.callback('enter', item);
  }
  exit(item) {
    this.callback('exit', item);
  }
  init(item) {
    this.callback('init', item);
  }
}